import useSWR, { SWRResponse } from "swr";
import { useClubSlug } from "../../Clubs/hooks";

const usePaymentTerms = (_clubSlug?: string): SWRResponse => {
    const clubSlug = useClubSlug(_clubSlug);
    const data = useSWR(clubSlug ? `invoice/${clubSlug}/payment-term` : null);
    return data;
};

export default usePaymentTerms;